import { Fragment } from "react";
import Head from "next/head";
import SinglePeople from "../../../components/SingleItem/SinglePeople";
import { ENDPOINTS, TAGS } from "../../../utils/api-endpoints";
import {
  getNextPrevIDs,
} from "../../../utils/GhostAPI";
import { redirectTo500 } from "../../../utils/utility";
import ghost from "../../../utils/ghost";
import { useRouter } from "next/router";

export const getStaticPaths = async () => {
  const allPosts = await ghost({filter: "tags:people",pagination:{limit:300}});
  const paths = allPosts.posts.map(post => ({
    params: {slug: post.slug},
  }));
  return {
    paths: paths,
    fallback: true,
  };
};
export async function getStaticProps(context) {
  const allPosts = await ghost({filter: "tags:people",pagination:{limit:300}});
  const slug = context.params.slug;
  const postData = (await ghost({filter: `slug:${slug}`})).posts[0];
  if (!postData) {
    return redirectTo500();
  }
  let nav = await getNextPrevIDs(context.params.slug);
  nav = nav === null ? {next: null, prev: null} : nav;
  return {
    props: {
      all:allPosts,
      post: postData,
      nav: nav,
    },
    revalidate: 3600,
  };
};

const SingleProfileDetails = props => {
  const router = useRouter();
  if (router.isFallback) {
    return <div>Loading...</div>;
  }
  return (
    <Fragment>
      <Head>
        <title>People | Best Software Company in Bangladesh</title>
        <meta
          name="description"
          content="DSi maintains a diverse pool of talents boasting more than 150 highly skilled software engineers. Aside from developers and QA engineers, teams at DSi include project managers, technical writers, and support engineers."
        />
      </Head>
      <div className="mid-home-column mt-10 mb-16 md:mt-9 md:mb-28">
        <div className="mx-5 md:mx-16">
          <SinglePeople
            post={props.post}
            path="/people/1"
            slug={props.post.slug}
            next={props.nav.next}
            prev={props.nav.prev}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default SingleProfileDetails;
